import { render, staticRenderFns } from "./TrackingDataTable.vue?vue&type=template&id=63d81906&scoped=true"
import script from "./TrackingDataTable.vue?vue&type=script&lang=js"
export * from "./TrackingDataTable.vue?vue&type=script&lang=js"
import style0 from "./TrackingDataTable.vue?vue&type=style&index=0&id=63d81906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d81906",
  null
  
)

export default component.exports